import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Box, IconButton, Tooltip } from '@mui/material';
import { LibraryAdd } from '@mui/icons-material';

import HeaderTitle from '../../../../atoms/HeaderTitle/HeaderTitle';
import { addCardAction } from '../../../../../sagas/cardManagment/addCard/action';

function VideoHeader({ variant }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleAdd = () => {
    dispatch(addCardAction({
      type: 'video',
    }));
  };
  return (
    <Box sx={{
      display: 'flex', width: '100%', justifyContent: 'space-between', color: variant === 'modal' ? 'primary.contrastText' : null,
    }}
    >
      <HeaderTitle text={t('VIDEO')} />
      {variant === 'page' && (
      <Box sx={{ pr: 1 }}>
        <Tooltip title={t('ADD_CARD_TO_GRID')} placement="left">
          <IconButton onClick={handleAdd}>
            <LibraryAdd />
          </IconButton>
        </Tooltip>
      </Box>
      )}
    </Box>
  );
}

VideoHeader.propTypes = {
  variant: PropTypes.string.isRequired,
};
export default VideoHeader;
